<template>
  <CFooter :fixed="false">
    <div class="float-right">
      Internal-dev
      <span class="ml-1">&copy; {{new Date().getFullYear()}} Lion Parcel.</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
